<script setup lang="ts"></script>

<template>
  <div class="bg-bg_gray px-2 py-6 md:py-10">
    <div class="mx-auto flex max-w-[768px] flex-col gap-y-5">
      <h2 class="text-center text-xl font-bold">このサイトについて</h2>
      <p>
        この「英語タイムアタック2025」は中学～高校レベルの英単語で構成された簡便な英語テストです。
      </p>
      <h3>注意事項</h3>
      <ul class="flex flex-col gap-y-2 text-sm">
        <li class="flex gap-x-1 before:content-['・']">
          本サイト「NHK出版ぷれぜんつ 英語タイムアタック2025」は
          NHK英語テキストのプロモーション用サイト「英語力測定テスト」の最新版として株式会社NHK出版が提供しております。
        </li>
        <li class="flex gap-x-1 before:content-['・']">
          このテストの結果は、あくまでひとつの目安です。
        </li>
        <li class="flex gap-x-1 before:content-['・']">
          本サイトで表示される統計データは、本サイトに入力された情報を集計したものです。
        </li>
        <li class="flex gap-x-1 before:content-['・']">
          本サイトで入力された情報は当サイトに関連する媒体での掲載を目的とするものです。なお、お答えいただいた回答を統計的に処理し、個人を特定できない形で販売促進やPR活動に利用することがございます。ご了承ください。
        </li>
        <li class="flex gap-x-1 before:content-['・']">
          本サイトに掲載されているコンテンツは私的使用その他法律によって明示的に認められる範囲を超えて、これらの情報を使用（複製、改変、ネットワーク上へのアップロード、掲示、送信、頒布、ライセンス、販売、出版等を含む）することを禁止します。
        </li>
        <li class="flex gap-x-1 before:content-['・']">
          本テストにおいて、通常想定されうる方法以外での回答をしたと思われる場合は、順位の表示や全国ランキングへの掲載を控えさせてさせていただく場合がございます。
        </li>
        <li class="flex gap-x-1 before:content-['・']">
          本サイトは、2026年1月30日の終了を予定しております。
        </li>
      </ul>
      <h3>免責</h3>
      <ul class="flex flex-col gap-y-2 text-sm">
        <li class="flex gap-x-1 before:content-['・']">
          本サイトのサービスの利用により、または利用できなかったことにより万一損害（データの破損・業務の中断・
          営業情報の損失などによる損害を含む）が生じ、たとえそのような損害の発生や第三者からの賠償請求の可能性があることについてあらかじめ知らされた場合でも、当社は一切責任を負いませんことをご了承ください。
        </li>
        <li class="flex gap-x-1 before:content-['・']">
          本サイトのサービスは予告なく中止、または内容や条件を変更する場合があります。
          あらかじめご了承ください。
        </li>
      </ul>
      <h3>推奨環境</h3>
      <ul class="flex flex-col gap-y-2 text-sm">
        <li class="flex gap-x-1 before:content-['・']">
          本サイトの推奨環境は次のとおりです。【PCでアクセスする場合のブラウザ】Google
          Chrome 最新版、Microsoft Edge 最新版、Safari
          最新版【スマートフォンでアクセスする場合のOSおよびブラウザ】<br />・iOS
          最新版、iPadOS 最新版、Safariブラウザ<br />・Android OS
          最新版、Chromeブラウザ
        </li>
      </ul>
    </div>
  </div>
</template>
